module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.gridTitle))]), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.value.headers,
      "items": _vm.value.data,
      "pagination": _vm.pagination,
      "select-all": "",
      "item-key": "id"
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', [(_vm.selectable) ? [_c('th', [_c('v-checkbox', {
          attrs: {
            "input-value": props.all,
            "indeterminate": props.indeterminate,
            "primary": "",
            "hide-details": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.$emit('toggleAll')
            }
          }
        })], 1)] : _vm._e(), _vm._v(" "), (_vm.editable) ? [_c('th')] : _vm._e(), _vm._v(" "), _vm._l((props.headers.slice(0, _vm.numColumns)), function(header) {
          return [(header.value != 'id') ? _c('th', {
            key: header.text,
            class: ['column sortable', _vm.pagination.descending ? 'desc' : 'asc', header.value === _vm.pagination.sortBy ? 'active' : ''],
            on: {
              "click": function($event) {
                return _vm.changeSort(header.value)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("arrow_upward")]), _vm._v("\n                        " + _vm._s(header.text) + "\n                    ")], 1) : _vm._e()]
        })], 2)]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('tr', [(_vm.selectable) ? [_c('td', {
          on: {
            "click": function($event) {
              props.selected = !props.selected
            }
          }
        }, [_c('v-checkbox', {
          attrs: {
            "input-value": props.selected,
            "primary": "",
            "hide-details": ""
          }
        })], 1)] : _vm._e(), _vm._v(" "), (_vm.editable) ? [_c('td', [_c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.$emit('editItem', props.item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "primary"
          }
        }, [_vm._v("edit")])], 1)], 1)] : _vm._e(), _vm._v(" "), _vm._l((_vm.value.headers.slice(0, _vm.numColumns)), function(header) {
          return [(_vm.expandable) ? [(header.value == 'hearingID') ? _c('td', {
            on: {
              "click": function($event) {
                props.expanded = !props.expanded
              }
            }
          }, [_c('router-link', {
            attrs: {
              "to": {
                name: 'HearingDetails',
                params: {
                  id: props.item[header.value],
                  editable: true
                }
              }
            }
          }, [_vm._v(_vm._s(props.item[header.value]))])], 1) : (header.value == 'eMail') ? _c('td', {
            on: {
              "click": function($event) {
                props.expanded = !props.expanded
              }
            }
          }, [_c('a', {
            attrs: {
              "href": 'mailto:' + props.item[header.value]
            }
          }, [_vm._v(_vm._s(props.item[header.value]))])]) : (header.value == 'complete' && props.item.complete == 1) ? _c('td', [_c('v-btn', {
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.$emit('completeItem', props.item)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "primary"
            }
          }, [_vm._v("done_outline")])], 1)], 1) : (header.value == 'complete' && props.item.complete == 0) ? _c('td') : (header.dataType == 'DateTime') ? _c('td', {
            on: {
              "click": function($event) {
                props.expanded = !props.expanded
              }
            }
          }, [_vm._v("\n                            " + _vm._s(_vm._f("formatDateTime")(props.item[header.value])) + "\n                        ")]) : (header.value == 'status') ? _c('td', {
            domProps: {
              "innerHTML": _vm._s(props.item[header.value])
            },
            on: {
              "click": function($event) {
                props.expanded = !props.expanded
              }
            }
          }) : (header.value != 'id') ? _c('td', {
            on: {
              "click": function($event) {
                props.expanded = !props.expanded
              }
            }
          }, [_vm._v("\n                            " + _vm._s(props.item[header.value]) + "\n                        ")]) : _vm._e()] : [(header.value == 'hearingID') ? _c('td', [_c('router-link', {
            attrs: {
              "name": "hearingID",
              "to": {
                name: 'HearingDetails',
                params: {
                  id: props.item[header.value],
                  editable: true
                }
              }
            },
            nativeOn: {
              "click": function($event) {
                return _vm.$emit('closed')
              }
            }
          }, [_vm._v(_vm._s(props.item[header.value]))])], 1) : (header.value == 'eMail') ? _c('td', [_c('a', {
            attrs: {
              "href": 'mailto:' + props.item[header.value]
            }
          }, [_vm._v(_vm._s(props.item[header.value]))])]) : (header.dataType == 'DateTime') ? _c('td', [_vm._v("\n                            " + _vm._s(_vm._f("formatDateTime")(props.item[header.value])) + "\n                        ")]) : (header.value != 'id') ? _c('td', [_vm._v("\n                            " + _vm._s(props.item[header.value]) + "\n                        ")]) : _vm._e()]]
        })], 2)]
      }
    }, (_vm.numColumns > 0) ? {
      key: "expand",
      fn: function(props) {
        return [_c('v-card', {
          attrs: {
            "flat": ""
          }
        }, [_c('tr', {
          attrs: {
            "name": "expandHeaders"
          }
        }, _vm._l((_vm.value.headers.slice(_vm.numColumns)), function(header) {
          return _c('th', [_vm._v(_vm._s(header.text))])
        }), 0), _vm._v(" "), _c('tr', {
          attrs: {
            "name": "expandDetails"
          }
        }, [_vm._l((_vm.value.headers.slice(_vm.numColumns)), function(header) {
          return [(header.value == 'status') ? _c('td', {
            domProps: {
              "innerHTML": _vm._s(props.item[header.value])
            }
          }) : (header.dataType == 'DateTime') ? _c('td', [_vm._v("\n                            " + _vm._s(_vm._f("formatDateTime")(props.item[header.value])) + "\n                        ")]) : _c('td', [_vm._v("\n                            " + _vm._s(props.item[header.value]) + "\n                        ")])]
        })], 2)])]
      }
    } : null], true),
    model: {
      value: (_vm.value.selected),
      callback: function($$v) {
        _vm.$set(_vm.value, "selected", $$v)
      },
      expression: "value.selected"
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3fa84a5b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fa84a5b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/src/components/grid/grid.vue.html
// module id = 585
// module chunks = 0